module.exports = __webpack_public_path__ + "img/infinity.b6407f68.jpeg";